import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestService } from 'src/app/shared/service/rest.service';
import { VehicleGroup } from '../model/vehicle-group';
import { classToPlain } from 'class-transformer';

@Injectable()
export class AdsVehicleGroupService extends RestService {

  getVehicleGroups(): Observable<VehicleGroup[]> {
    return this.getAndExtract<VehicleGroup>(VehicleGroup, 'api/ads/group/fetch');
  }

  deleteVehicleGroup(groupId: number): Observable<any> {
    return this.deleteAndExtractSingle<VehicleGroup>(VehicleGroup, `api/ads/group/delete/${groupId}`);
  }

  saveVehicleGroup(vehicleGroup: VehicleGroup): Observable<any> {
    const payload = classToPlain(vehicleGroup);
    return this.doPost('api/ads/group/save', payload);
  }
}
